const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function initials(name?: string): string {
  if (!name) return "RT";
  return name
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function successBarColor(rate: number): string {
  if (rate > 75) return "#059669";
  if (rate >= 60) return "#D97706";
  return "#DC2626";
}

export function formatJoined(joinedAt?: string | null): string {
  if (!joinedAt) return "—";
  const d = new Date(joinedAt);
  if (!isNaN(d.getTime())) {
    const day = String(d.getDate()).padStart(2, "0");
    return `${day} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
  }
  return joinedAt;
}

export const SORT_OPTIONS: { value: string; label: string }[] = [
  { value: "Newest First", label: "Newest First" },
  { value: "Oldest First", label: "Oldest First" },
  { value: "Most Mandates", label: "Most Mandates" },
  { value: "Highest Success Rate", label: "Highest Success Rate" },
];

// Indian states and union territories, for the retailer form's State field.
export const INDIAN_STATES: string[] = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];
